export const courtRegExp =
  /^st[mjf]$|^ts[ute]$|^tr[fet]$|^trf-?\d+$|^tre-?[a-z]{2}$|^trt-?\d+$|^tc[ue]$|^tce-?[a-z]{2}$|^tnu$|^cnj$|^tj-?[a-z]{2}$|^tj(m|(m-?[a-z]{2}))$|^t[jf]$/i
